import React from 'react';
import { BookOpen, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { isInternalDocLink } from '../../config/helpLinks';

/**
 * Inline help banner — documentation links stay in-app under /articles.
 */
export default function HelpBanner({
  title = 'Need help?',
  description,
  docHref,
  articleTo,
  linkLabel = 'Read guide',
  className = '',
}) {
  const href = docHref || articleTo;
  const internal = isInternalDocLink(href);

  return (
    <div
      className={`rounded-lg border border-border/60 bg-muted/30 px-4 py-3 text-sm ${className}`}
    >
      <div className="flex flex-wrap items-start gap-3 justify-between">
        <div className="flex gap-2 min-w-0">
          <BookOpen className="h-5 w-5 shrink-0 text-primary mt-0.5" aria-hidden />
          <div>
            <p className="font-medium text-foreground">{title}</p>
            {description && <p className="text-muted-foreground mt-0.5">{description}</p>}
          </div>
        </div>
        {href && (
          internal ? (
            <Link to={href} className="inline-flex items-center gap-1 text-primary hover:underline shrink-0">
              {linkLabel}
            </Link>
          ) : (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline shrink-0"
            >
              {linkLabel}
              <ExternalLink className="h-3.5 w-3.5" aria-hidden />
            </a>
          )
        )}
      </div>
    </div>
  );
}
